exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumb-col[data-v-5e8810dc] {\n  width: 100%;\n  text-align: center;\n}\n@media (min-width: 1024px) {\n.thumb-col[data-v-5e8810dc] {\n    width: 100px;\n}\n}\n@media (min-width: 1124px) {\n.thumb-col[data-v-5e8810dc] {\n    width: 150px;\n}\n}\n", ""]);

// exports
